/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MembersCreateFromEmailInvite } from '../../models/members-create-from-email-invite';
import { MembersWithoutSupplierData } from '../../models/members-without-supplier-data';

export interface InviteSupplierApiV2MembersSupplierPost$Params {
  org: string;
      body: MembersCreateFromEmailInvite
}

export function inviteSupplierApiV2MembersSupplierPost(http: HttpClient, rootUrl: string, params: InviteSupplierApiV2MembersSupplierPost$Params, context?: HttpContext): Observable<StrictHttpResponse<MembersWithoutSupplierData>> {
  const rb = new RequestBuilder(rootUrl, inviteSupplierApiV2MembersSupplierPost.PATH, 'post');
  if (params) {
    rb.query('org', params.org, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MembersWithoutSupplierData>;
    })
  );
}

inviteSupplierApiV2MembersSupplierPost.PATH = '/api/v2/members/supplier';
